import { render, staticRenderFns } from "./form-login-crypto-pro.vue?vue&type=template&id=4b2f0424&"
import script from "./form-login-crypto-pro.vue?vue&type=script&lang=js&"
export * from "./form-login-crypto-pro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../tmp/ffsecurity-ui/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports